export default __webpack_public_path__ + "static/media/ib-telegram.fabf8b25.svg";